"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../../index");
var react_1 = __importDefault(require("react"));
function VideoSave(_a) {
    var onSave = _a.onSave;
    return react_1.default.createElement("div", null,
        react_1.default.createElement(index_1.Texts.Heading, { type: 'h3', appendClassname: 'mb-2' }, "Video inkorten"),
        react_1.default.createElement(index_1.Texts.Primary, { appendClassname: 'mb-4' }, "Het inkorten van deze video kan niet ongedaan worden gemaakt, weet je het zeker?"),
        react_1.default.createElement(index_1.Buttons.Button, { type: 'primary', onClick: onSave },
            react_1.default.createElement("span", null, "Doorgaan")));
}
exports.default = VideoSave;
